import React, { useState } from "react";
// @ts-ignore - Reusable modal is in JS
import HReusableAlertModal from "../hcomponents/HReusableAlertModal";

interface LogoutModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({ show, onClose, onConfirm }) => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleConfirm = async () => {
    setIsLoggingOut(true);
    await onConfirm();
    setIsLoggingOut(false);
  };

  return (
    <HReusableAlertModal
      isOpen={show}
      onClose={onClose}
      onConfirm={handleConfirm}
      title="Sign Out"
      description="Are you sure you want to sign out?"
      confirmLabel="Confirm"
      loadingLabel="Logging out..."
      isLoading={isLoggingOut}
    />
  );
};

export default LogoutModal;
